import React from "react";
import {EmployeeDashboardProps} from "@widgets/timeRegistration/EmployeeDashboard";
import {EmployeeStatus} from "@/data/entities/employee";
import ClockOutOption from "@widgets/timeRegistration/authenticated/clocking/ClockOutOption";
import ClockInOption from "@widgets/timeRegistration/authenticated/clocking/ClockInOption";


type Props = EmployeeDashboardProps & {
    employee: EmployeeStatus,
    isClockedIn: boolean,
};

const ClockToggle = ({isClockedIn, employee, setEmployee}: Props) => {
    if (isClockedIn) {
        return (
            <ClockOutOption
                employee={employee}
                setEmployee={setEmployee}
            />
        );
    }

    return (
        <ClockInOption
            employee={employee}
            setEmployee={setEmployee}
        />
    );
};

export default ClockToggle;